import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { StateService } from '@services/state.service';

/*Models */
import { DeviceState } from '@models/device-state';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'state-info',
  templateUrl: './state-info.component.html'
})
export class StateInfoComponent implements OnDestroy {
  state: DeviceState;
  public stateInfo = {
    message: [],
    icon: []
  };
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private stateService: StateService) {

    this.stateService.stateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(state => {
        this.state = state;
        this.setStateObject();
      });
  }

  setStateObject() {
    let prior = 0;
    let currentPrior = 0;
    this.stateInfo = {
      message: [],
      icon: []
    };
    /*prior 10 */
    currentPrior = 10;
    if (this.state.mainStates.guard) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }
      if (this.stateInfo.message.indexOf('Охрана') < 0) {
        this.stateInfo.message.push('Охрана');
      }

      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }

    }
    /*end prior 10 */
    if (this.state.mainStates.alarm) {

      this.stateInfo.message = [];
      this.stateInfo.icon = [];
      this.stateInfo.icon.push('red_lock');
      this.stateInfo.message.push('Тревога');

    }
    /*prior 20 */
    currentPrior = 20;
    if (this.state.mainStates.activeGuard) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }
      if (this.stateInfo.message.indexOf('Активная охрана') < 0) {
        this.stateInfo.message.push('Активная охрана');
      }

      if (this.stateInfo.icon.indexOf('secure_on') < 0) {
        this.stateInfo.icon.push('secure_on');
      }
    }
    /*end prior 20 */

    /*prior 30 */
    currentPrior = 30;

    if (this.state.mainStates.valet) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      if (this.stateInfo.message.indexOf('Режим Автосервис') < 0) {
        this.stateInfo.message.push('Режим Автосервис');
      }
      if (this.stateInfo.icon.indexOf('valet') < 0) {
        this.stateInfo.icon.push('valet');
      }
    }
    if (this.state.mainStates.ign) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }
      if (this.stateInfo.message.indexOf('Зажигание включено') < 0) {
        this.stateInfo.message.push('Зажигание включено');
      }

      if (this.stateInfo.icon.indexOf('blue_key') < 0 && !this.state.mainStates.autostart) {
        this.stateInfo.icon.push('blue_key');
      }

    }


    /*end prior 30  */
    /*prior 35 */
    currentPrior = 40;
    if (this.state.mainStates.autostart) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }
      if (this.stateInfo.message.indexOf('Автозапуск') < 0) {
        this.stateInfo.message.push('Автозапуск');
      }

      if (this.stateInfo.icon.indexOf('blue_key') < 0) {
        this.stateInfo.icon.push('blue_key');
      }
      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
    }
    /*end prior 35  */

    /*prior 40 */
    currentPrior = 40;


    if (this.state.alarmStates.shockLow) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      this.stateInfo.message.push('Слабый удар');

      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
      if (this.stateInfo.icon.indexOf('shock') < 0) {
        this.stateInfo.icon.push('shock');
      }
    }

    if (this.state.alarmStates.shockHigh) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      this.stateInfo.message.push('Сильный удар');

      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
      if (this.stateInfo.icon.indexOf('shock') < 0) {
        this.stateInfo.icon.push('shock');
      }
    }


    if (this.state.alarmStates.tilt) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      this.stateInfo.message.push('Наклон');

      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
      if (this.stateInfo.icon.indexOf('slope') < 0) {
        this.stateInfo.icon.push('slope');
      }
    }

    if (this.state.alarmStates.ign) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      this.stateInfo.message.push('Зажигание');

      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
      if (this.stateInfo.icon.indexOf('red_key') < 0) {
        this.stateInfo.icon.push('red_key');
      }
    }

    if (this.state.alarmStates.hBrake || this.state.alarmStates.pBrake) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      this.stateInfo.message.push('Тормоз');
      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
      if (this.stateInfo.icon.indexOf('brake') < 0) {
        this.stateInfo.icon.push('brake');
      }
    }
    if (this.state.alarmStates.move) {
      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }
      this.stateInfo.message.push('Движение');

      if (this.stateInfo.icon.indexOf('blue_lock') < 0) {
        this.stateInfo.icon.push('blue_lock');
      }
      if (this.stateInfo.icon.indexOf('slope') < 0) {
        this.stateInfo.icon.push('slope');
      }
    }


    if (this.state.alarmStates.hood) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      if (this.stateInfo.message.indexOf('Охрана') < 0) {
        this.stateInfo.message.push('Охрана');
      }
      if (this.stateInfo.icon.indexOf('blue_lock') >= 0) {
        this.stateInfo.icon.splice(this.stateInfo.icon.indexOf('blue_lock'), 1);
      }
      if (this.stateInfo.icon.indexOf('red_lock') < 0) {
        this.stateInfo.icon.push('red_lock');
      }
    }
    if (this.state.alarmStates.trunk) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      if (this.stateInfo.message.indexOf('Охрана') < 0) {
        this.stateInfo.message.push('Охрана');
      }
      if (this.stateInfo.icon.indexOf('blue_lock') >= 0) {
        this.stateInfo.icon.splice(this.stateInfo.icon.indexOf('blue_lock'), 1);
      }
      if (this.stateInfo.icon.indexOf('red_lock') < 0) {
        this.stateInfo.icon.push('red_lock');
      }
    }
    if (
      this.state.alarmStates.doorBackLeft ||
      this.state.alarmStates.doorBackRight ||
      this.state.alarmStates.doorFrontLeft ||
      this.state.alarmStates.doorFrontRight) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }
      if (this.stateInfo.message.indexOf('Охрана') < 0) {
        this.stateInfo.message.push('Охрана');
      }
      if (this.stateInfo.icon.indexOf('blue_lock') >= 0) {
        this.stateInfo.icon.splice(this.stateInfo.icon.indexOf('blue_lock'), 1);
      }
      if (this.stateInfo.icon.indexOf('red_lock') < 0) {
        this.stateInfo.icon.push('red_lock');
      }

    }
    if (this.state.alarmStates.hijack) {

      if (prior < currentPrior) {
        prior = currentPrior;
        this.stateInfo.message = [];
        this.stateInfo.icon = [];
      }

      if (this.stateInfo.message.indexOf('Ограбление') < 0) {
        this.stateInfo.message.push('Ограбление');
      }
      if (this.stateInfo.icon.indexOf('blue_lock') >= 0) {
        this.stateInfo.icon.splice(this.stateInfo.icon.indexOf('blue_lock'), 1);
      }
      if (this.stateInfo.icon.indexOf('red_lock') < 0) {
        this.stateInfo.icon.push('red_lock');
      }
    }
    if ((this.state.alarmStates.shockLow ||
      this.state.alarmStates.shockHigh ||
      this.state.alarmStates.tilt ||
      this.state.alarmStates.ign ||
      this.state.alarmStates.hBrake ||
      this.state.alarmStates.pBrake ||
      this.state.alarmStates.move) && this.stateInfo.message.indexOf('Охрана') > 0) {
      this.stateInfo.message.splice(this.stateInfo.message.indexOf('Охрана'), 1);
    }


    /*end prior 40  */
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/components/state-info/state-info.component.ts